const showWishModal = (
  signupText = "Become a Roomie and create your wishlist!",
  subheaderSigninText = "Sign-in to create your wishlist.",
  becomeRoomieLinkieText = "Become a Roomie now and create your wishlist!"
) => {
  const modal = document.getElementById("room-ask-key-modal");

  if(!modal){
    return;
  }
  const subheader = document.getElementById("modal-subheader");
  const subheaderSignin = document.getElementById("signin-subheader");
  const becomeRoomieLinkie = document.querySelector(".become-roomie-linkie");


  subheaderSignin.innerHTML = subheaderSigninText;
  subheader.innerHTML = signupText;
  becomeRoomieLinkie.innerHTML = becomeRoomieLinkieText;

 let redirectLink = window.location.href
  if(signupText.includes("wishlist")) {
redirectLink = "/pages/my-wishlist"
  }
// set redirect url
modal.querySelector('[name="checkout_url"]').value = redirectLink;
modal.querySelector('[name="return_to"]').value = redirectLink
  modal.style.display = "block";
};

const closeWishModal = () => {
  const modal = document.getElementById("room-ask-key-modal");
  modal.style.display = "none";
};

// Wishlist functionality
document.addEventListener("DOMContentLoaded", async () => {
  const urlParams = new URLSearchParams(window.location.search);
  const userid = window.wish?.id;
  const useremail = window.wish?.email;
  const externalRoomieId =
    urlParams.get("roomie") === "null" ? "" : urlParams.get("roomie");

  const wishUrl =
    window.location.hostname === "127.0.0.1"
      ? "http://localhost:8888"
      : "https://the-room-app.vercel.app";

  console.log("❤️");
  const wishButtons = document.querySelectorAll("button.wish");

  const headerButton = document.getElementById("wish-list-header-button");

  if (headerButton) {
    headerButton.addEventListener("click", () => {
      if (userid) {
        location.href = "/pages/my-wishlist";
      } else {
        showWishModal();
      }
    });
  }

  if (!userid && !externalRoomieId) {
    console.log("No user id or email");
    wishButtons.forEach((button) => {
      button.style.display = "block";
      button.addEventListener("click", () => {
        showWishModal();
      });
    });

    // TODO wishbuttons add click to show modal to become roomie.

    return;
  }

  const fetchUrl = externalRoomieId
    ? wishUrl + "/api/wishlist?roomie=" + externalRoomieId
    : wishUrl + "/api/wishlist?userId=" + userid;

  if (externalRoomieId) {
    const titlle = document.querySelector(".my-wishlist-title");
    if (titlle) {
      titlle.innerHTML = "Your Roomies' Wishlist";
      const allWishesData = await fetch(fetchUrl);
      const allWishes = await allWishesData.json();
      fillUpMyWishlist(allWishes);
    }
    const noWishItems = document.querySelectorAll(".no-wish-items");
    noWishItems.forEach((noWishItem) => {
      noWishItem.style.display = "none";
    });

    const shareButton = document.querySelector(".share-button");
    if (shareButton) {
      shareButton.style.display = "none";
    }
  } else {
    // add eventlisteners to the selects
    const selectVartiantWishes = document.querySelectorAll(
      ".select-variant-wish"
    );
    selectVartiantWishes.forEach((select) => {
      select.addEventListener("change", (e) => {
        // const button = select.parentElement.querySelector("button");
        const productId = select.dataset.productId;

        fetch(wishUrl + "/api/wishlist", {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            customerId: userid,
            productId,
            variantId: e.target.value,
          }),
        });
      });
    });

    //
    // if we are on wishlist page fetch the wishlist
    if (window.location.pathname === "/pages/my-wishlist") {
      const allWishesData = await fetch(fetchUrl);
      const allWishes = await allWishesData.json();

      // set the sizes of the selects
      allWishes.forEach((wish) => {
        const select = document.querySelector(
          `select[data-product-id="${wish.id}"]`
        );
        if (select && wish.variantId) {
          select.value = wish.variantId;

          const previousNotifications =
            localStorage.getItem("notifiedWishes")?.split(",") || [];
          // get selected variant
          const oopt = select.querySelector(
            `option[value="${wish.variantId}"]`
          );
          const isSoldOut = oopt.dataset.soldout === "true";

          if (previousNotifications.includes(wish.variantId)) {
            select.nextElementSibling.innerHTML = "You will be notified";
            select.nextElementSibling.disabled = true;
            return;
          } else {
            select.nextElementSibling.disabled = false;
            select.nextElementSibling.innerHTML = isSoldOut
              ? "Notify me when available"
              : "Add to cart";
          }
        }
      });
    }
  }

  wishButtons.forEach((button) => {
    button.style.display = "block";
    const articleId = button.dataset.id;
    const image = button.dataset.image;
    const title = button.dataset.title;
    const price = button.dataset.price;
    const link = button.dataset.link;
    const variantIds = button.dataset.variantids;
    const variantTitles = button.dataset.varianttitles;

    // check if the item is already in the wishlist
    if (
      (window.wish?.wishedIds?.split(",") || []).find(
        (wish) => wish === articleId
      )
    ) {
      button.classList.add("liked");
    }

    // add eventlistners to click the heart
    button.addEventListener("click", (e) => {
      if (e.target.classList.contains("liked")) {
        e.target.classList.remove("liked");

        fetch(wishUrl + "/api/wishlist", {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            itemId: articleId,
            customerId: userid,
            customerEmail: useremail,
          }),
        });

        const wishesCounter = document.querySelector(".wishes-counter");
        wishesCounter.innerHTML = parseInt(wishesCounter.innerHTML) - 1;
      } else {
        e.target.classList.add("liked");

        if (!userid || !useremail) {
          alert("You need to be logged in to add items to your wishlist");
          return;
        }

        fetch(wishUrl + "/api/wishlist", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            item: {
              id: articleId,
              image,
              title,
              price,
              link,
              variantIds,
              variantTitles,
            },
            customerId: userid,
            customerEmail: useremail,
          }),
        });
        const wishesCounter = document.querySelector(".wishes-counter");
        wishesCounter.innerHTML = parseInt(wishesCounter.innerHTML) + 1;
      }
    });
  });

  const addToCartButtons = document.querySelectorAll(".add-to-cart");

  addToCartButtons.forEach((button) => {
    button.addEventListener("click", async (e) => {
      e.target.disabled = true;

      const articleId = e.target.dataset.id;
      const variant = e.target.parentElement.querySelector("select");
      const variantId = variant ? variant.value : articleId;
      const notifyMe = e.target.innerHTML.includes("Notify me");
      const willBeNotified = e.target.innerHTML.includes(
        "You will be notified"
      );

      if (willBeNotified) {
        console.log("You will be notified");
        return;
      }
      // check if sold out
      if (notifyMe) {
        if (!window.wish.email) {
          document.getElementById("notify-modal").classList.add("show");
          window.wish.variantId = variantId;
          e.target.disabled = false;
          return;
        }
        const body = {
          a: "YurRAQ",
          email: window.wish.email,
          variant: variantId,
          platform: "shopify",
        };

        fetch("https://the-room-app.vercel.app/api/subscribe", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        }).then(() => {
          e.target.innerHTML = "You will be notified";
          const notifiedWishes =
            localStorage.getItem("notifiedWishes")?.split(",") || [];
          notifiedWishes.push(variantId);

          localStorage.setItem("notifiedWishes", notifiedWishes);
        });
      } else {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1,
                properties: {
                  _added_from: "wishlist",
                },
              },
            ],
            sections: [
              "cart-notification-product",
              "cart-notification-button",
              "cart-icon-bubble",
            ],
          }),
        });

        const data = await response.json();
        console.log(response);
        if (response.status === 200) {
          e.target.innerHTML = "Added to cart";
          e.target.disabled = false;
          const cartIconBubble = document.querySelector("#cart-icon-bubble");
          cartIconBubble.innerHTML = data.sections["cart-icon-bubble"];

          const cartIconCart = document.querySelector(
            "#cart-notification-product"
          );
          cartIconCart.innerHTML = data.sections["cart-notification-product"];

          const cartIconButton = document.querySelector(
            "#cart-notification-button"
          );
          cartIconButton.innerHTML = data.sections["cart-notification-button"];
          this.cart =
            document.querySelector("cart-notification") ||
            document.querySelector("cart-drawer");
          this.cart.open();
          // const cartCounter = document.querySelector(".cart-count-bubble");
          // cartCounter.innerHTML = parseInt(cartCounter.innerHTML) + 1;
        }

        if (response.status === 422) {
          e.target.innerHTML = "Sold out";
          e.target.disabled = true;
        }
      }
    });
  });
});
